<style src="css/testDetail.css" scoped></style>
<template>
    <div style="padding-top: .98rem;">
        <topbar text="开始测试"></topbar>
        <div class="pic" :style="{background: `url(${EnvUrl}${scaleInfoDetail.bigPic}) no-repeat center/cover`}"></div>
        <div class="mainBox">

            <div class="testTitle">{{scaleInfoDetail.title}} </div>
            <div class="content" v-html="scaleInfoDetail.content"></div>

            <div class="centerBox">
                <div class="centerItem">
                    {{scaleInfoDetail.testCountStr}}
                    <div class="itemName">参与人数</div>
                </div>
                <div class="centerItem">
                    {{scaleInfoDetail.questionCount}}题
                    <div class="itemName">题目数</div>
                </div>
                <div class="centerItem">
                    {{Math.ceil(scaleInfoDetail.questionCount/10)}}分钟
                    <div class="itemName">建议用时</div>
                </div>
            </div>
            <div class="btnBox" @click="getScaleQuestionList">开始测试</div>
        </div>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                scaleInfoDetail:{},
                scaleId:'',
                testId:'',
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {
            to(n) {
                this.$router.push(`/${n}`)
            },
            async getScaleQuestionList() {

                    let data = await getSources("/bear-scale/api/scaleInfoQuestion/getScaleQuestionList.json", {
                        scaleId: this.scaleId,
                        userId: localStorage.getItem('userId'),
                        testId: this.testId
                    });
                    if (data.status === 0) {
                        if (data.needPay) {
                            this.to(`pay?scaleId=${this.scaleId}&testId=${data.testId}&count=${data.count}`)
                        } else {
                            this.to(`topic?scaleId=${this.$route.query.scaleId}&testId=${data.testId}`)
                        }
                    } else {
                        alert(data.msg)
                    }

            },
            async getScaleInfoDetail() {
                let obj = {}
                obj.scaleId = this.$route.query.scaleId;
                obj.companyId=localStorage.getItem('companyId');
                obj.userId = localStorage.getItem('userId');
                let data = await getSources("/bear-scale/api/scaleInfo/getScaleInfoDetail.json", obj);
                if (data.status === 0) {
                    this.scaleInfoDetail = data.scaleInfoDetail
                }else{
                    alert(data.msg)
                }
            },
        },
        destroyed(){

        },
        mounted() {
          if(!localStorage.getItem('userId')){
            if(this.$route.query.code){
              this.$router.push(`/login?next=${encodeURIComponent(this.$route.fullPath)}&code=${this.$route.query.code}`)
            }else{
              this.$router.push(`/login?next=${encodeURIComponent(this.$route.fullPath)}`)
            }
            return
          }
            this.scaleId=this.$route.query.scaleId;
            if(this.$route.query.testId){
                this.testId = this.$route.query.testId;
            }
            this.getScaleInfoDetail();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/testDetail.vue?4cd2bda9